import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { css } from '@emotion/react'
import { LinkBox } from '../link/Link'

import './Table.less'

export default class Table extends PureComponent<{
  children: any
  className?: string
}> {
  render() {
    const { children, className } = this.props
    const cssClasses = classNames('Table', className)
    return <table className={cssClasses}>{children}</table>
  }
}

export const TableBody = ({
  children,
  className
}: {
  children: any
  className?: string
}) => {
  const cssClasses = classNames('TableBody', className)
  return <tbody className={cssClasses}>{children}</tbody>
}

export const TableRow = ({
  children,
  className,
  onClick,
  condensedForMobile,
  withHover
}: {
  children: any
  className?: string
  onClick?: () => void
  condensedForMobile?: boolean
  withHover?: boolean
}) => {
  const cssClasses = classNames('TableRow', className, {
    condensedForMobile,
    withHover
  })
  return (
    <LinkBox
      as="tr"
      css={css`
        cursor: ${withHover ? 'pointer' : 'inherit'};
      `}
      onClick={onClick}
      className={cssClasses}
    >
      {children}
    </LinkBox>
  )
}

export const TableCol = ({
  children,
  className,
  collapsing = false,
  colSpan = 1
}: {
  children: any
  className?: string
  collapsing?: boolean
  colSpan?: number
}) => {
  const cssClasses = classNames('TableCol', className, {
    collapsing
  })
  return (
    <td colSpan={colSpan} className={cssClasses}>
      {children}
    </td>
  )
}
